var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tooltip',{attrs:{"content":_vm.$t('全屏'),"placement":"bottom","effect":"light"}},[_c('div',{class:_vm.icon,on:{"click":_vm.click}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }